import * as signalR from '@microsoft/signalr';
import Config from './Config';
/**
 * 通讯客户端
 */
export default class SignalRClient {
    private static instance: SignalRClient;
    private connection: signalR.HubConnection;
    public static get Instance() : SignalRClient {
        if (this.instance == null) {
            this.instance = new SignalRClient();
        }
        return this.instance;
    }
    
    constructor() {
        this.connection = new signalR.HubConnectionBuilder()
            .withUrl(Config.hubUrl)
            .withAutomaticReconnect() //自动重连
            .build();
        this.connection.onreconnected(() => {
            console.log('重连成功!');
        });
        this.connection.onreconnecting(() => {
            console.log('重连中!');

        });
        this.connection.onclose(async () => {
            console.log("连接断开!")
        });
    }

    /**
     * 添加监听
     */
    public AddEventListener(key: string, onBackFun: (...args: any[]) => void) {
        this.connection.on(key, onBackFun);
    }

    /**
     * 删除监听
     * @param key 
     */
    public RemoveEventListener(key: string) {
        this.connection.off(key);
    }

    /**
     * 启动服务
     */
    public async StartAsync() {
        await this.connection.start();
    }

    /**
     * 发送数据并返回
     * @param args 
     * @returns 
     */
    public async InvokeAsync<T>(action: string, ...args: any[]) {
        return await this.connection.invoke(action, ...args) as T;
    }

    /**
     * 发送数据不返回
     * @param action 
     * @param args 
     */
    public async SendAsync(action: string, ...args: any[]) {
        await this.connection.send(action, ...args)
    }
}